import { prop, compose, path } from 'ramda';

import { landing } from 'app/features/landing/selectors';

const viewPlansCta = compose(prop('viewPlansCta'), landing);
const heroBlockViewPlansCtaText = compose(
  path(['heroBlock', 'textKey']),
  viewPlansCta,
);
const devicesViewPlansCtaText = compose(
  path(['devices', 'textKey']),
  viewPlansCta,
);

export { heroBlockViewPlansCtaText, devicesViewPlansCtaText };
